import { useWindowDimensions } from 'react-native'
import { ProgressIndicator } from '../progress-indicator'
import { Container, ProgressIndicatorContainer } from './stepper.styles'
import type { TStepperProps } from './types'

export const Stepper = ({
  testID,
  steps,
  completed,
  ...rest
}: TStepperProps) => {
  const componentProperties = {
    testID,
    steps,
    completed,
    ...rest,
  }
  const { width } = useWindowDimensions()

  if (steps > 7) {
    throw new Error('O número máximo permitido para steps é 7.')
  }

  if (completed > steps) {
    throw new Error(
      'A propriedade completed não pode ser maior que a propriedade steps.'
    )
  }

  if (steps <= 0) {
    return null
  }

  const gapBetweenItems = 8
  const maxGap = steps * gapBetweenItems
  const stepPaddingHorizontal = 32
  const totalWidthToRemoveFromScreenWidth = stepPaddingHorizontal + maxGap

  const unityWidth = (width - totalWidthToRemoveFromScreenWidth) / steps

  return (
    <Container {...componentProperties}>
      {Array.from({ length: steps }, (_, index) => {
        const isCompleted = index < completed
        return (
          <ProgressIndicatorContainer
            key={index.toString()}
            testID="progress-indicator-container"
            style={{ width: unityWidth }}
          >
            <ProgressIndicator
              size="nano"
              variant="neutral"
              testID="progress-indicator"
              percentage={isCompleted ? 100 : 0}
            />
          </ProgressIndicatorContainer>
        )
      })}
    </Container>
  )
}

export type { TStepperProps }
